import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function RedirectHandler() {
  const { type, id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Store to localStorage
    localStorage.setItem('redirectData', JSON.stringify({ type, id }));
    if (type === 'subscription' && id?.length > 5) {
      navigate(`/subscription?redirectId=${id}`, { replace: true });
      return;
    }
    if (type === 'warranty' && id?.length > 5) {
      navigate(`/warranty?redirectId=${id}`, { replace: true });
      return;
    }
    if (type === 'event' && id?.length > 5) {
      navigate(`/safalevent?redirectId=${id}`, { replace: true });
      return;
    }
    // Redirect to /
    navigate('/', { replace: true });
  }, []);

  return null; // Render nothing
}

export default RedirectHandler;
